module.exports = __webpack_public_path__ + "img/wz-7-3-6.166fb26d.jpg";